export interface CheckInFieldDefinition {
    /** Form field name */
    field: string;
    /** Validation message shown when the field is required but empty */
    requiredMessage: string;
}

export const CheckInFields = Object.freeze({
    ASSET_SIZE: { field: "assetSize", requiredMessage: "Please enter an asset size." },
    ASSET_TYPE: { field: "assetType", requiredMessage: "Please select an equipment type." },
    CHASSIS_LICENSE_PLATE_NUMBER: { field: "chassisLicensePlateNumber", requiredMessage: "Please enter the chassis license plate number." },
    CHASSIS_NUMBER: { field: "chassisNumber", requiredMessage: "Please enter the chassis number" },
    CONTAINER_NUMBER: { field: "containerNumber", requiredMessage: "Please enter a container number." },
    DRIVER_FIRST_NAME: { field: "driverFirstName", requiredMessage: "Please enter the driver's first name." },
    DRIVER_LAST_NAME: { field: "driverLastName", requiredMessage: "Please enter the driver's last name." },
    DRIVER_LICENSE_NUMBER: { field: "driverLicenseNumber", requiredMessage: "Please enter the driver license number of the driver." },
    NOTES: { field: "notes", requiredMessage: "" },
    SEAL_NUMBER: { field: "sealNumber", requiredMessage: "Please enter a seal number." },
    TRAILER_NUMBER: { field: "trailerNumber", requiredMessage: "Please enter the trailer number." },
    TRUCK_LICENSE_PLATE_NUMBER: { field: "truckLicensePlateNumber", requiredMessage: "Please enter the truck license plate number." }
} satisfies Record<string, CheckInFieldDefinition>)
